import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Guía IA para Profes de Lengua',
    subtitle: '"ChatGPT es tu Asistente"',
    desc: '20 prompts listos para planificar, crear actividades y responder mensajes de padres en segundos.',
    val: '$12.000',
    img: 'https://cdn.magicpatterns.com/uploads/1uRjUnodpFeNPgpnTKuS8v/51.png'
  }, {
    num: '02',
    title: 'Kit "Sin Drama" — 30 Comunicados Listos para Enviar',
    subtitle: '',
    desc: 'Mensajes de WhatsApp y cuaderno para padres en cualquier situación: notas, conducta, citaciones y más.',
    val: '$10.000',
    img: 'https://cdn.magicpatterns.com/uploads/mzJqocxzve6qskV2v3U6pK/50.png'
  }, {
    num: '03',
    title: 'Planilla Maestra de Notas',
    subtitle: '',
    desc: 'Sistema de registro con semáforo automático para detectar alumnos en riesgo antes de que sea tarde.',
    val: '$9.000',
    img: 'https://cdn.magicpatterns.com/uploads/2KaAQ2ddkkqScxaXCmUkDs/49.png'
  }, {
    num: '04',
    title: 'Semáforo Docente de Seguimiento',
    subtitle: '',
    desc: 'Fichas individuales por alumno y mapa del curso visual para ver quién necesita ayuda de un vistazo.',
    val: '$8.000',
    img: 'https://cdn.magicpatterns.com/uploads/iE3ryBkGrxsUGK9nScpRRA/53.png'
  }, {
    num: '05',
    title: 'Plantillas de Recuperatorios',
    subtitle: '',
    desc: '6 modelos listos para primaria y secundaria. Con solucionario y criterios de corrección incluidos.',
    val: '$7.000',
    img: 'https://cdn.magicpatterns.com/uploads/aQtsoHcisSPJ8zutRbtX1b/52.png'
  }, {
    num: '06',
    title: 'Pack Organización Semanal Docente',
    subtitle: '"Domingo Sin Caos"',
    desc: 'Rutina de 15 minutos para ordenar toda la semana antes de que empiece. Planificador semanal, mensual y anual.',
    val: '$9.000',
    img: 'https://cdn.magicpatterns.com/uploads/oGN8NSHY97ApRPaWSnkTxj/54.png'
  }];
  return <section className="py-16 bg-gray-900 text-white" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500 rounded-full mb-6" data-id="element-18">
            <Gift className="w-8 h-8 text-white" data-id="element-19" />
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-20">
            Más los 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-gray-300 font-medium" data-id="element-21">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-22">
          {bonuses.map((b, i) => <div key={i} className="bg-gray-800 rounded-2xl overflow-hidden border border-gray-700 flex flex-col" data-id="element-23">
              <a href="#comprar" className="block cursor-pointer relative group" data-id="element-24">
                {/* TODO: replace with bonus images so user can swap easily */}
                <img src={b.img} alt={`Bonus ${b.num}: ${b.title}`} loading="lazy" decoding="async" className="w-full aspect-square object-cover opacity-90 group-hover:opacity-100 transition-opacity" data-id="element-25" />
                <div className="absolute top-4 left-4 bg-orange-500 text-white font-black px-3 py-1 rounded-lg text-sm" data-id="element-26">
                  BONUS {b.num}
                </div>
              </a>
              <div className="p-6 flex flex-col flex-grow" data-id="element-27">
                <h3 className="text-xl font-bold mb-1" data-id="element-28">{b.title}</h3>
                {b.subtitle && <p className="text-orange-400 font-medium mb-3" data-id="element-29">
                    {b.subtitle}
                  </p>}
                <p className="text-gray-400 text-sm mb-6 flex-grow" data-id="element-30">{b.desc}</p>

                <div className="mt-auto pt-4 border-t border-gray-700 flex items-center justify-between" data-id="element-31">
                  <span className="text-gray-500 line-through" data-id="element-32">
                    Valor {b.val}
                  </span>
                  <span className="bg-green-500 text-white font-bold px-3 py-1 rounded text-sm" data-id="element-33">
                    → GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}